<template>
  <div class="main notice-page">
    <div class="main_r">
      <div class="page-top">
        <div class="title_line">消息列表</div>

        <div class="stats-bar">
          <div class="stat-card stat-total">
            <span class="stat-value">{{ dataListnum }}</span>
            <span class="stat-label">消息总数</span>
          </div>
          <div class="stat-card stat-system">
            <span class="stat-value">{{ noticeStats.system }}</span>
            <span class="stat-label">系统消息（本页）</span>
          </div>
          <div class="stat-card stat-activity">
            <span class="stat-value">{{ noticeStats.activity }}</span>
            <span class="stat-label">活动消息（本页）</span>
          </div>
        </div>

        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">消息类型</label>
              <el-select v-model="queryData.noticeType" placeholder="全部" size="small">
                <el-option label="全部" value="0"></el-option>
                <el-option label="系统消息" value="1"></el-option>
                <el-option label="活动消息" value="2"></el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">消息标题</label>
              <el-input v-model="queryData.noticeTitle" placeholder="输入标题" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">消息内容</label>
              <el-input v-model="queryData.noticeContent" placeholder="输入内容" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">起始日期</label>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">结束日期</label>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
            <span class="filter-strip__sep"></span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="clickdialogAdd">新增</el-button>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="table-section">
        <div class="table-container" ref="tableContainer">
          <el-table
            :data="dataList"
            class="notice-table"
            :height="tableHeight"
            :header-cell-style="tableHeaderStyle"
            :cell-style="tableCellStyle"
            @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
            <el-table-column prop="noticeType" label="消息类型" width="110" sortable="custom" align="center">
              <template slot-scope="props"><el-tag :type="props.row.noticeType == 1 ? 'primary' : 'warning'" size="small" effect="plain" style="vertical-align:middle">{{ props.row.noticeType == 1 ? '系统消息' : '活动消息' }}</el-tag></template>
            </el-table-column>
            <el-table-column prop="noticeTitle" label="消息标题" min-width="150" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="noticeContent" label="消息内容" min-width="200" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" sortable="custom" class-name="col-mono"></el-table-column>
            <el-table-column label="英文标题" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="translation-text">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['notice_title']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="德文标题" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="translation-text">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['notice_title']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Operation" label="操作" width="140" fixed="right" align="center">
              <template slot-scope="scope">
                <div class="action-group">
                  <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                    <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="翻译" placement="top" :enterable="false">
                    <el-link :underline="false" type="warning" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-link>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="dataListnum">
        </el-pagination>
      </div>

      <!---------------------- 以下是弹框内容 ---------------------->
      <!-- 添加消息 -->
      <el-dialog title="添加消息" :visible.sync="dialogAdd" width="26%" class="newAdd">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="addData" label-width="80px">
            <el-form-item label="消息类型" :required=true>
              <el-select v-model="addData.noticeType" placeholder="消息类型">
                <el-option label="系统消息" value="1"></el-option>
                <el-option label="活动消息" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消息标题" :required=true>
              <el-input v-model="addData.noticeTitle" placeholder="请输入消息标题"></el-input>
            </el-form-item>
            <el-form-item label="消息内容" :required=true>
              <el-input v-model="addData.noticeContent" placeholder="请输入消息内容"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="NoticeInsert()" >确定</el-button>
          <el-button @click="dialogAdd = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 添加消息 End -->

      <!-- 编辑信息 -->
      <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editData" label-width="80px">
            <el-form-item label="消息类型" :required=true>
              <el-select v-model="editData.noticeType" placeholder="消息类型">
                <el-option label="系统消息" value="1"></el-option>
                <el-option label="活动消息" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消息标题" :required=true>
              <el-input v-model="editData.noticeTitle" placeholder="请输入消息标题"></el-input>
            </el-form-item>
            <el-form-item label="消息内容" :required=true>
              <el-input v-model="editData.noticeContent" placeholder="请输入消息内容"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="NoticeUpdate()" >确定</el-button>
          <el-button @click="dialogEdit = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑信息 End -->

      <!-- 翻译管理 -->
      <i18n-translation-dialog
        :visible.sync="dialogI18n"
        :entity-type="i18nEntityType"
        :entity-id="i18nEntityId"
        :fields="i18nFields">
      </i18n-translation-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: { I18nTranslationDialog },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        noticeType: '0',
        noticeTitle: '',
        noticeContent: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        noticeType: '1',
        noticeTitle: '',
        noticeContent: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        noticeType: '',
        noticeTitle: '',
        noticeContent: ''
      },
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'NOTICE',
      i18nFields: [
        { name: 'notice_title', label: '消息标题', type: 'input' },
        { name: 'notice_content', label: '消息内容', type: 'textarea' }
      ],
      translationMap: {}
    }
  },
  computed: {
    noticeStats () {
      return {
        total: this.dataListnum,
        system: this.dataList.filter(item => item.noticeType == 1).length,
        activity: this.dataList.filter(item => item.noticeType == 2).length
      }
    }
  },
  mounted () {
    this.NoticeList()
    this.NoticeNum()
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.property === 'Operation' || column.property === 'noticeType' || column.property === 'id') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.NoticeList()
      this.NoticeNum()
    },
    clickQuery () {
      this.page_no = 1
      this.NoticeList()
      this.NoticeNum()
    },
    clickQueryReset () {
      this.queryData.noticeType = '0'
      this.queryData.noticeTitle = ''
      this.queryData.noticeContent = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.noticeType = '1'
      this.addData.noticeTitle = ''
      this.addData.noticeContent = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.notice = row.notice
      this.editData.noticeType = row.noticeType.toString()
      this.editData.noticeTitle = row.noticeTitle
      this.editData.noticeContent = row.noticeContent
    },
    ClickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除？').then(function () {
        that.NoticeDelete(row.id)
      })
    },
    NoticeList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryData.noticeType
      data.noticeTitle = that.queryData.noticeTitle
      data.noticeContent = that.queryData.noticeContent
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('NOTICE', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryData.noticeType
      data.noticeTitle = that.queryData.noticeTitle
      data.noticeContent = that.queryData.noticeContent
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.addData.noticeType
      data.noticeTitle = that.addData.noticeTitle
      data.noticeContent = that.addData.noticeContent
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeList()
            that.NoticeNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    NoticeUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.noticeType = that.editData.noticeType
      data.noticeTitle = that.editData.noticeTitle
      data.noticeContent = that.editData.noticeContent
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeList()
            that.NoticeNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    NoticeDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeList()
            that.NoticeNum()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  watch: {
    dialogI18n (val) {
      if (!val) {
        this.loadTranslations('NOTICE', this.dataList, 'id')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  NoticeManagement · 运动主题设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.notice-page {
  /* 页面级 CSS 变量，基于全局 design-system.css */
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 统计卡片组 */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.stat-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.06);
  transition: all 200ms ease;
  position: relative;
  overflow: hidden;

  /* 左侧彩色装饰条 */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: var(--aptus-primary);
    border-radius: 8px 0 0 8px;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(15, 26, 46, 0.1);
    transform: translateY(-1px);
  }

  .stat-value {
    font-size: 24px;
    font-weight: 700;
    color: var(--aptus-text);
    line-height: 1.2;
  }

  .stat-label {
    font-size: 12px;
    color: var(--aptus-text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

/* 各统计卡片主题色 */
.stat-total::before { background: var(--aptus-primary); }
.stat-total .stat-value { color: var(--aptus-primary); }

.stat-system::before { background: var(--aptus-success); }
.stat-system .stat-value { color: var(--aptus-success); }

.stat-activity::before { background: var(--aptus-accent); }
.stat-activity .stat-value { color: var(--aptus-accent); }

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 消息表格 */
.notice-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .translation-text {
    color: var(--aptus-text-secondary);
    font-size: 13px;
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }

    &.el-link--warning:hover {
      background-color: var(--aptus-accent-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 1200px) {
  .stats-bar {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .notice-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .stats-bar {
    grid-template-columns: 1fr 1fr;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

/* 删除确认弹窗 · 屏幕垂直居中 */
.confirmDel /deep/ .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.confirmDel /deep/ .el-dialog__body {
  padding: 20px 24px;
}

.confirmMsg {
  font-size: 15px;
  color: var(--aptus-text);
  text-align: center;
  padding: 10px 0;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}
</style>
